import type { PgTable } from "drizzle-orm/pg-core";

import { BulkInserter, type BulkInsertOptions } from "@storyboard/db-utils/helper/BulkInserter";
import { db } from "./db";
import type * as schema from "./schema";

const inserter = new BulkInserter(db);

export async function bulkInsert(
  table: PgTable,
  rows: Object[],
  options?: BulkInsertOptions<typeof schema>,
): Promise<void> {
  await inserter.insert(table, rows as Record<string, unknown>[], options);
}
